import { Message } from 'ant-design-vue'
import { toLogin } from './utils'
import { report } from './reportError'
export function hasNeedLoginKeyWords(res) {
  const resStr = JSON.stringify(res)
  return resStr.includes(2001502) || resStr.includes('重新登录商家管理后台') || resStr.includes('请重新登录供应商协同系统')
}

const modules = {
  'cms': {
    handle: (url, res) => {
      const json = res.data
      const traceId = res.headers['x-trace-id'] || ''
      if (json.code * 1 === 0) {
        return json.data
      } else if (json.code * 1 === 1024) {
        toLogin()
      } else {
        // Message.info((res && res.message) || '系统异常，请稍后再试')
        report({
          url,
          res: json,
          traceId,
          msg: json && json.message
        })
        return []
      }
    }
  },
  'mapi': {//1024未登陆，0成功
    handle: (url, res) => {
      const json = res.data
      const traceId = res.headers['x-trace-id'] || ''
      if (json.code * 1 === 0) {
        return json.data
      } else if (json.code * 1 === 1024) {
        toLogin()
      } else {
        Message.info((res && res.message) || '系统异常，请稍后再试')
        report({
          url,
          res: json,
          traceId,
          msg: json && json.message
        })
        return []
      }
    },
  },
  // 'portal': {
  //   handle: (url, res) => {
  //     const json = res.data
  //     if (json.code * 1 === 1) {
  //       return json.data || []
  //     } else if (json.code * 1 === 3 || json.code * 1 === 4) {
  //       toLogin()
  //     } else {
  //       Message.info((res && res.msg) || '系统异常，请稍后再试')
  //       console.log(url)
  //       report({
  //         url,
  //         res: json,
  //         msg: json.msg
  //       })
  //       return {}
  //     }
  //   }
  // }
  // 'popmanage': {
  //   handle: (url, res) => {
  //     const { success, code } = res
  //     if (success || code * 1 === 1) {
  //       return res
  //     } else if (isInWhiteList(url)) {
  //       return res
  //     } else {
  //       notification.destroy()
  //       const args = {
  //         message: '错误',
  //         description: res.msg,
  //         duration: 0,
  //       }
  //       notification.error(args)
  //       WriteSentryError(res.msg, url, res)
  //     }
  //     return res
  //   }
  // },
  // 'seller': {
  //   handle: (url, res) => {
  //     const { success, code } = res
  //     if (success || code * 1 === 1) {
  //       return res
  //     } else {
  //       notification.destroy()
  //       const args = {
  //         message: '错误',
  //         description: res.msg,
  //         duration: 0,
  //       }
  //       notification.error(args)
  //       WriteSentryError(res.msg, url, res)
  //     }
  //     return res
  //   }
  // },
}

export default modules
